import { MutableRefObject, useEffect, useRef } from 'react'

export const useOutsideClick = (callback: Function) => {
  const ref: MutableRefObject<any> = useRef(null)

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback()
      }
    }

    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [callback, ref])

  return ref
}
